export default __webpack_public_path__ + "static/media/groupware-mail-1.2239292d.png";